import React from 'react';
import Highlight from '../../shared/highlight';
import "./highlight-panel.css";
import { t, getCurrentLanguage } from '../../../utils/translations';
import useLanguageStore from '../../../store/languageStore';

class HighlightPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 0,
            currentLanguage: getCurrentLanguage()
        };
    }

    componentDidMount() {
        // Subscribe to language changes
        this.unsubscribe = useLanguageStore.subscribe((state) => {
            this.setState({ currentLanguage: state.currentLanguage });
        });
    }

    componentWillUnmount() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    }

    handleTabClick = (tabIndex) => {
        this.setState({ activeTab: tabIndex });
    }

    render() {
        const { activeTab, currentLanguage } = this.state;
        
        const tabs = [
            {
                title: t('solucoes_cross', currentLanguage),
                content: [
                    <Highlight key="backoffice" text={t('backoffice', currentLanguage)} link="https://tdn.totvs.com/x/SdA6Ow" />,
                    <Highlight key="rh" text={t('recursos_humanos', currentLanguage)} link="https://tdn.totvs.com/x/X9A6Ow" />,
                    <Highlight key="taf" text={t('taf_automacao', currentLanguage)} link="https://tdn.totvs.com/x/dNA6Ow" />,
                    <Highlight key="tss" text={t('tss', currentLanguage)} link="https://tdn.totvs.com/x/mtA6Ow" />,
                ]
            },
            {
                title: t('solucao_segmentos', currentLanguage),
                content: [
                    <Highlight key="juridico" text={t('juridico', currentLanguage)} link="https://tdn.totvs.com/x/2dA6Ow" />,
                    <Highlight key="manufatura" text={t('manufatura', currentLanguage)} link="https://tdn.totvs.com/x/9dA6Ow" />,
                    <Highlight key="saude" text={t('saude', currentLanguage)} link="https://tdn.totvs.com/x/CdE6Ow" />,
                    <Highlight key="varejo" text={t('varejo', currentLanguage)} link="https://tdn.totvs.com/x/HNE6Ow" />,
                    <Highlight key="logistica" text={t('logistica', currentLanguage)} link="https://tdn.totvs.com/x/MtE6Ow" />,
                    <Highlight key="locacao" text={t('locacao', currentLanguage)} link="https://tdn.totvs.com/x/RNE6Ow" />,
                    <Highlight key="agricola" text={t('gestao_agricola', currentLanguage)} link="https://tdn.totvs.com/x/sNA6Ow" />,
                    <Highlight key="professional" text={t('professional_services', currentLanguage)} link="https://tdn.totvs.com/x/x9A6Ow" />
                ]
            }
        ];

        return (
            <div className="highlight-panel">
                <div className="highlight-panel-title-group">
                    <h4 className="highlight-panel-product-name">{t('linha_protheus', currentLanguage)}</h4>
                    <h1 className="highlight-panel-title">{t('novidades_release', currentLanguage)}</h1>
                </div>
                
                <div className="highlight-panel-tabs">
                    {tabs.map((tab, index) => (
                        <button
                            key={index}
                            className={`highlight-tab-button ${activeTab === index ? 'active' : ''}`}
                            onClick={() => this.handleTabClick(index)}
                        >
                            {tab.title}
                        </button>
                    ))}
                </div>
                
                <div className="highlight-panel-content">
                    <div className="highlight-tab">
                        {tabs[activeTab].content}
                    </div>
                </div>
            </div>
        );
    }
};

export default HighlightPanel;